import {
  createIsLoadingSelector,
  developerByIdSelector,
  makeNullSafeDomainGetter,
} from 'store/state/domainData/selectors/common';

export const isDeveloperLoadingSelector = createIsLoadingSelector(developerByIdSelector);
export const rawDeveloperSelector = makeNullSafeDomainGetter(developerByIdSelector, 'developerById');
